import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";

import LoginComponent from "../../../../components/loginComponent/loginComponent";
import { getLoginScopes } from "../../msal/constants";
import { settings } from "../../settings/settings";

const LoginPage: React.FC = () => {
    const { instance } = useMsal();
    const [loginHint, setLoginHint] = useState<string>();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const loginHintParam = urlParams.get('login_hint');
        if (loginHintParam) {
            setLoginHint(loginHintParam)
        }
    }, [])

    const onLogin = () => {
        instance.loginRedirect({
            scopes: [...getLoginScopes()],
            prompt: 'login',
            loginHint,
            authority: settings.authority
        })
    };

    return <LoginComponent onLogin={onLogin} />
}

export default LoginPage;